var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"receipt"},[_c('div',{staticClass:"container"},[(!_vm.isContentReady)?_c('div',{staticClass:"loading"},[_c('loader-content',{attrs:{"isDisplay":true}})],1):_vm._e(),(_vm.isContentReady)?_c('order-receipt',{attrs:{"orderDetail":_vm.orderDetail}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }